import { useEffect, useState } from "react"

export const useReportes = () => {

    const [cantidad, setCantidad] = useState( 0 )

    const [mostrarAlerta, setMostrarAlerta] = useState( false )

    const sumar = () => {
        setCantidad( cantidad + 1 )
    }

    useEffect(() => {
      
        if ( cantidad > 10 ) {
            setMostrarAlerta( true )
        }

    }, [ cantidad ])
    


    return {
        cantidad, sumar, mostrarAlerta
    }
}

/*

{} son para envolver variables

() son para envolver etiquetas

useState

useEffect

hooks

react js

*/
